var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Box as BoxBase, Flex as FlexBase } from 'reflexbox';
import { color, space } from 'styled-system';
import { css, mq, styled } from "../utils";
export var Box = BoxBase;
export var Grid = styled.div(function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 auto;\n    box-sizing: border-box;\n    width: 100%;\n    flex-grow: 1;\n    max-width: ", ";\n\n    ", "\n  "], ["\n    margin: 0 auto;\n    box-sizing: border-box;\n    width: 100%;\n    flex-grow: 1;\n    max-width: ", ";\n\n    ",
        "\n  "])), theme.breakpoints[theme.breakpoints.length - 1], mq({
        padding: ['0 8px', '0 8px', '0 16px', '0 24px'],
    }));
}, space, color);
export var Flex = FlexBase;
export var Row = FlexBase;
export var Col = Box;
Col.defaultProps = {
    px: 1,
};
var templateObject_1;
//# sourceMappingURL=grid.js.map